// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/tools/variable-manager/index.less
// module id = 8
// module chunks = 0 1 2